import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import appDisplay from 'scoreboard/components/app-display'
import Report from 'scoreboard/reports/report'
import configBackground from '../wob-background-menu'
import ConfigReportLabel from './config-report-label'
import WidgetConfigMenu from '../widget-config-menu'
import fontSizeMenu from '../font-size-menu'
import wobTablePaddingMenu from '../wob-table-padding-menu'
import ReportDialogEditor from 'scoreboard/dashboards/widgets/report/report-dialog-editor'
import cloneDeepWithDatasetShallow from 'scoreboard/datasets/clone-deep-with-dataset-shallow'

var ReportWidgetConfig = WidgetConfigMenu.extend({
	typeSpecificTargets: function (hasTemplate) {
		const editReport = {
			type: 'dialog',
			label: 'report.customReport.editReport',
			target: function (e) {
				// #55557 don't cloneDeep the report, because it locks the CPU
				let clone = cloneDeepWithDatasetShallow(this.model.get('report'))
				const report = new Report(clone).toSubtype()
				report.editing = true
				appDisplay.dialog(report.fetch(), () => {
					const reportEditor = new ReportDialogEditor({ model: report })
					reportEditor.on('done', updatedReport => {
						this.model.trigger('record')
						this.model.set('report', updatedReport.attributes)
					})
					return reportEditor
				})

				e.preventDefault()
				this.trigger('done')
			}.bind(this)
		}

		var editLabel = {
			type: 'dialog',
			label: 'dashboards.setReportTitle',
			target: function (e) {
				var configView = new ConfigReportLabel({
					model: this.model
				})

				appDisplay.dialog(configView)

				e.preventDefault()
				this.trigger('done')
			}.bind(this)
		}

		let target = [
			editReport,
			editLabel,
			fontSizeMenu(this.model.properties, {
				// #36756 Fonts as relative offsets to the below size
				baseSize: 14
			}),
			wobTablePaddingMenu(this.model.properties),
			configBackground(this.model.properties)
		]

		if (this.model.properties.get('reportSubtype') !== 'scorecard-structure') {
			target.push({
				type: 'toggle',
				label: 'dashboards.display.columnHeaders',
				contentView: ShowHeadersToggle,
				model: this.model.properties
			})
		}

    return target
	}
})

var ShowHeadersToggle = BootslideMenu.WidgetToggleProperty.extend({
	property: {
		name: 'showHeaders',
		label: 'dashboards.display.columnHeaders'
	},
	val: function() {
		// #36756 Treat unset value as true; show headers by default unless
		// explicitly configured not to
		const val =
			BootslideMenu.WidgetToggleProperty.prototype.val.apply(this, arguments)
		return val !== false
	}
})


export default ReportWidgetConfig

ReportWidgetConfig.__filename__ = 'dashboards/widgets/report/report-widget-config.js'
